


































import { Component } from 'vue-property-decorator'
import { AbstractModuleForm } from '../../abstract/form'
import {
  ProductApplicationSliderModule, ProductApplicationSliderModuleContent,
  ProductApplicationSliderModuleContentInput
} from '../ProductApplicationSlider.contracts'
import {
  productApplicationSliderContentFactory
} from '../ProductApplicationSlider.factory'
import { DashmixSelectItem, SizeMap } from '@movecloser/ui-core'

@Component<ProductApplicationSliderModuleForm>({
  name: 'ProductApplicationSliderModuleForm',
})
export class ProductApplicationSliderModuleForm extends AbstractModuleForm<ProductApplicationSliderModuleContentInput, ProductApplicationSliderModule> {
  public initialContent: ProductApplicationSliderModuleContent = productApplicationSliderContentFactory()

  public get headingOptions (): DashmixSelectItem[] {
    const options = []

    for (let i = 1; i < 7; i++) {
      options.push({
        label: `${i}`,
        value: i
      })
    }

    return options
  }

  public get headingDisplaySizeOptions (): DashmixSelectItem[] {
    const options = []

    for (const [key, value] of Object.entries(SizeMap)) {
      if (value !== SizeMap.XLarge) {
        options.push({
          label: key,
          value
        })
      }
    }

    return options
  }
}

export default ProductApplicationSliderModuleForm
